import styled from 'styled-components';
export default styled.ol.withConfig({
  displayName: "LinkList",
  componentId: "sc-7bfpwq-0"
})(["padding-bottom:0;"]);